import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ShippingTypePostalCodesMapApi - axios parameter creator
 * @export
 */
const ShippingTypePostalCodesMapApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAll: async (sid, options = {}) => {
            const localVarPath = `/v1/ShippingTypePostalCodesMap/DeleteAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sid !== undefined) {
                localVarQueryParameter['sid'] = sid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/ShippingTypePostalCodesMap/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByShippingType: async (id, options = {}) => {
            const localVarPath = `/v1/ShippingTypePostalCodesMap/GetByShippingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {Array<ShippingTypePostalCodesMapToken>} [ShippingTypePostalCodesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ShippingTypePostalCodesMapToken, options = {}) => {
            const localVarPath = `/v1/ShippingTypePostalCodesMap/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ShippingTypePostalCodesMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertAll: async (id, options = {}) => {
            const localVarPath = `/v1/ShippingTypePostalCodesMap/InsertAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/ShippingTypePostalCodesMap/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShippingTypePostalCodesMapApi - functional programming interface
 * @export
 */
const ShippingTypePostalCodesMapApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShippingTypePostalCodesMapApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAll(sid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAll(sid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypePostalCodesMapApi.deleteAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypePostalCodesMapApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByShippingType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByShippingType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypePostalCodesMapApi.getByShippingType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {Array<ShippingTypePostalCodesMapToken>} [ShippingTypePostalCodesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ShippingTypePostalCodesMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ShippingTypePostalCodesMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypePostalCodesMapApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertAll(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertAll(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypePostalCodesMapApi.insertAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypePostalCodesMapApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ShippingTypePostalCodesMapApi - factory interface
 * @export
 */
const ShippingTypePostalCodesMapApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShippingTypePostalCodesMapApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [sid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAll(sid, options) {
            return localVarFp.deleteAll(sid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByShippingType(id, options) {
            return localVarFp.getByShippingType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {Array<ShippingTypePostalCodesMapToken>} [ShippingTypePostalCodesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ShippingTypePostalCodesMapToken, options) {
            return localVarFp.insert(ShippingTypePostalCodesMapToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertAll(id, options) {
            return localVarFp.insertAll(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShippingTypePostalCodesMapApi - object-oriented interface
 * @export
 * @class ShippingTypePostalCodesMapApi
 * @extends {BaseAPI}
 */
class ShippingTypePostalCodesMapApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [sid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypePostalCodesMapApi
     */
    deleteAll(sid, options) {
        return ShippingTypePostalCodesMapApiFp(this.configuration).deleteAll(sid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypePostalCodesMapApi
     */
    getById(id, options) {
        return ShippingTypePostalCodesMapApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypePostalCodesMapApi
     */
    getByShippingType(id, options) {
        return ShippingTypePostalCodesMapApiFp(this.configuration).getByShippingType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {Array<ShippingTypePostalCodesMapToken>} [ShippingTypePostalCodesMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypePostalCodesMapApi
     */
    insert(ShippingTypePostalCodesMapToken, options) {
        return ShippingTypePostalCodesMapApiFp(this.configuration).insert(ShippingTypePostalCodesMapToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypePostalCodesMapApi
     */
    insertAll(id, options) {
        return ShippingTypePostalCodesMapApiFp(this.configuration).insertAll(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypePostalCodesMapApi
     */
    remove(id, options) {
        return ShippingTypePostalCodesMapApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ShippingTypePostalCodesMapApi, ShippingTypePostalCodesMapApiAxiosParamCreator, ShippingTypePostalCodesMapApiFactory, ShippingTypePostalCodesMapApiFp };
//# sourceMappingURL=shipping-type-postal-codes-map-api.js.map
